// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-24e908c7] .number-name-wrapper{overflow:hidden}[data-v-24e908c7] .number-name-wrapper .name-wrapper{text-overflow:ellipsis;overflow:hidden}.v-tabs-items[data-v-24e908c7]{overflow:visible}", ""]);
// Exports
module.exports = exports;
